import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { Capacitor } from '@capacitor/core';
import { AuthService } from 'src/app/services/auth.service';
import { AppConfigurationService } from 'src/app/services/app.configuration.service';

@Component({
  selector: 'fun-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.scss']
})
export class ViewerComponent implements OnInit, OnChanges {

  @Input() file: any;
  @Input() imageList: any;
  @Input() zoom: any;
  @Input() maxHeight: any;
  @Output() public errorEvent = new EventEmitter<any>();
  @Output() public pageChangeEvent = new EventEmitter<any>();
  @Output() public pageNumberEvent = new EventEmitter<any>();

  loading: boolean;
  zoomNumber;
  pdfSrc: any;

  constructor(
    public chdRef: ChangeDetectorRef,
    private authService: AuthService,
    private appConfigurationService: AppConfigurationService
  ) { }

  ngOnInit() {
    // Must be set before <pdf-viewer> is created (i.e. before pdfSrc is assigned)
    // so that ng2-pdf-viewer's constructor picks up our local worker
    // instead of falling back to the CDN
    (window as any).pdfWorkerSrc = 'assets/pdf.worker.min.js';

    this.zoomNumber = this.zoom !== null && this.zoom !== undefined ? this.zoom : 1.7;
    this.pageChangeEvent.emit({ pageNumber: 1 });
    this.chdRef.detectChanges();
  }

  ngOnChanges() {
    this.loading = true;
    this.pdfSrc = undefined;
    this.loadPdf();
    this.chdRef.detectChanges();
  }

  loadPdf() {
    if (!this.file) {
      return;
    }

    // pdfjs hace su propio fetch por fuera de HttpClient/AuthInterceptor. En nativo seguimos
    // añadiendo siempre la cabecera (comportamiento ya existente, vía CapacitorHttp). En web antes
    // se pasaba la URL tal cual asumiendo que era pública (S3); ahora también añadimos el token si
    // la URL es de nuestro propio backend, o el visor se queda colgado con un 401/403.
    const isOwnApiUrl = typeof this.file === 'string' && this.file.startsWith(this.appConfigurationService.get('domain'));
    const needsAuthHeader = typeof this.file === 'string' && (Capacitor.isNativePlatform() || isOwnApiUrl);
    if (!needsAuthHeader) {
      this.pdfSrc = this.file;
      return;
    }

    const token = this.authService.authData?.accessToken;
    this.pdfSrc = token
      ? { url: this.file, httpHeaders: { Authorization: `Bearer ${token}` }, withCredentials: false }
      : { url: this.file };
    this.chdRef.detectChanges();
  }

  callBackFn(event) {
    this.loading = false;
    this.chdRef.detectChanges();
  }

  onError(event) {
    this.errorEvent.emit();
    this.chdRef.detectChanges();
  }

  pagechanging(event) {
    this.pageChangeEvent.emit(event);
    this.chdRef.detectChanges();
  }

  afterLoadComplete(pdf: PDFDocumentProxy) {
    this.pageNumberEvent.emit(pdf.numPages);
    this.chdRef.detectChanges();
  }

}
